'use client'

import * as React from 'react'
import { Folder, Keyboard, Palette } from 'lucide-react'
import {
  CommandDialog,
  CommandEmpty,
  CommandGroup,
  CommandInput,
  CommandItem,
  CommandList,
  CommandSeparator,
  CommandShortcut,
} from '@/ui/command'
import { useHotkeys } from 'react-hotkeys-hook'
import { shortcuts } from '.'

export interface ShortcutsCommandProps {
  shortcut: (v: typeof shortcuts) => string
}
export function ShortcutsCommand({ shortcut, children }: React.PropsWithChildren<ShortcutsCommandProps>) {
  const [open, setOpen] = React.useState(false)

  useHotkeys(shortcut(shortcuts), () => {
    setOpen((prev) => !prev)
  })

  const renderTrigger = () => {
    if (children)
      return (
        <div onClick={() => setOpen(true)} className="cursor-pointer">
          {children}
        </div>
      )
    else return null
  }

  return (
    <>
      {renderTrigger()}
      <CommandDialog open={open} onOpenChange={setOpen}>
        <CommandInput placeholder="Введите команду или выполните поиск..." />
        <CommandList>
          <CommandEmpty>Ничего не найдено.</CommandEmpty>
          <CommandGroup heading="Предложения">
            <CommandItem>
              <Folder className="mr-2 h-4 w-4" />
              <span>{shortcuts.projectsPopup.label}</span>
              <CommandShortcut>
                <kbd className="pointer-events-none inline-flex h-5 select-none items-center gap-1 rounded border bg-muted px-1.5 font-mono text-[10px] font-medium text-muted-foreground opacity-100">
                  <span className="text-xs">{shortcuts.projectsPopup.shortcut}</span>
                </kbd>
              </CommandShortcut>
            </CommandItem>
          </CommandGroup>
          <CommandSeparator />
          <CommandGroup heading="Настройки">
            <CommandItem>
              <Keyboard className="mr-2 h-4 w-4" />
              <span>{shortcuts.shortcuts.label}</span>
              <CommandShortcut>
                <kbd className="pointer-events-none inline-flex h-5 select-none items-center gap-1 rounded border bg-muted px-1.5 font-mono text-[10px] font-medium text-muted-foreground opacity-100">
                  <span className="text-xs">{shortcuts.shortcuts.shortcut}</span>
                </kbd>
              </CommandShortcut>
            </CommandItem>

            <CommandItem>
              <Palette className="mr-2 h-4 w-4" />
              <span>{shortcuts.paletteCommand.label}</span>
              <CommandShortcut>
                <kbd className="pointer-events-none inline-flex h-5 select-none items-center gap-1 rounded border bg-muted px-1.5 font-mono text-[10px] font-medium text-muted-foreground opacity-100">
                  <span className="text-xs">{shortcuts.paletteCommand.shortcut}</span>
                </kbd>
              </CommandShortcut>
            </CommandItem>
          </CommandGroup>
        </CommandList>
      </CommandDialog>
    </>
  )
}
